var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 7.99984C0.666748 12.0499 3.94999 15.3332 8.00008 15.3332C12.0502 15.3332 15.3334 12.0499 15.3334 7.99984C15.3334 3.94975 12.0502 0.666504 8.00008 0.666504C3.94999 0.666504 0.666748 3.94975 0.666748 7.99984ZM14.0001 7.99984C14.0001 11.3135 11.3138 13.9998 8.00008 13.9998C4.68637 13.9998 2.00008 11.3135 2.00008 7.99984C2.00008 4.68613 4.68637 1.99984 8.00008 1.99984C11.3138 1.99984 14.0001 4.68613 14.0001 7.99984ZM8.66916 9.33207H9.33538V10.6654H6.66872V9.33207H7.33538V7.99873H6.66872V6.6654H8.66916V9.33207ZM8.66719 5.33207C8.66719 5.70026 8.36861 5.99873 8.0003 5.99873C7.63199 5.99873 7.33342 5.70026 7.33342 5.33207C7.33342 4.96388 7.63199 4.6654 8.0003 4.6654C8.36861 4.6654 8.66719 4.96388 8.66719 5.33207Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.d59522b9e4245466f1ce393d4629c390.svg";
export { ForwardRef as ReactComponent };